import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VExpansionPanel,_vm._b({staticClass:"panel",model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},'v-expansion-panel',_vm.$attrs,false),[_c(VExpansionPanelHeader,{attrs:{"color":"element"}},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c(VExpansionPanelContent,[_vm._v(" "+_vm._s(_vm.content && _vm.content)+" "),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }